// extracted by css-extract-rspack-plugin
export default {"container":"AgentQRSection-module__container","qrImage":"AgentQRSection-module__qrImage","textLine":"AgentQRSection-module__textLine"};